export default "__VITE_ASSET__Br8Bb2Zy__"